import { makeStyles } from "@fluentui/react-components";

const globalStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "left",
  },
  cardContainer: {
    borderRadius: "0em !important",
    boxShadow: "none !important",
  },
  fontStyle: {
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.5",
    letterSpacing: "normal",
  },
  font16: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#001737",
  },
  font12: {
    fontSize: "12px",
    fontWeight: "normal",
    color: '#546176',
  },
  font14: {
    fontSize: "14px",
    fontWeight: "normal",
    color: '#546176',
  },
  fontBold14: {
    fontSize: "14px",
    fontWeight: "bold",
    color: '#546176',
  },
  signOutLink:{
    color: '#007ac9',
    fontSize: '14px',
    fontWeight: 'normal',
  },

  anchorDetail: {
    color: "#fff",
    textDecoration: "fff",
    ":hover": {
      color: "#fff",
    },
  },
  // New style for the header container
  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between", // Pushes the button to the far right
    width: "100%", // Ensure it spans the full width
  },
  // Style to group the icon and title together
  titleContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px", // Space between the icon and title
  },
  greenButton: {
    backgroundColor: "#278838", // Green background
    color: "#fff", // White text for contrast
    ":hover": {
      backgroundColor: "#1f6d2d", // Slightly darker green on hover
      color: "#fff",
    },
    ":active": {
      backgroundColor: "#1e7e34", // Even darker green on active
    },
    fontWeight: "normal",
  },
  switchContainer: {
      display: "flex",
      justifyContent: "space-between", // Pushes the switch to the right
      alignItems: "center",
      width: "100%", // Ensure the container takes full width
      paddingRight: "12px", // Optional: Add padding to ensure the switch isn't too close to the edge
    },
    label: {
      marginRight: "auto", // Pushes the label to the left
      fontSize: "14px",
      color: '#546176',
    },
    popoverSurface: {
        backgroundColor: "#1E2556 !important",
        color: "#ffffff !important",
        borderRadius: "4px !important",
        boxShadow: "0 4px 14px rgba(0, 0, 0, 0.4) !important",
        padding: "0px 10px 0px 10px !important",
        fontSize: "14px !important",
        maxWidth: "240px !important",
        zIndex: 1000,
      },
});
export default globalStyles;
